import React, { useEffect, useState } from "react";
import { FormValidator, useFormValidator, Inputs } from "coaz-ui";
import client from "../client";

const EditTopic = ({ params, submitRef, setLoading, setEnableSubmit }) => {
  const topicId = params ? params.id : null;
  const [topic, setTopic] = useState(null);
  const { request, errorMessage } = client;

  const submit = async () => {
    try {
      await request("PUT", "topics", topic);
      return { message: "Successful", success: true };
    } catch (error) {
      return { message: errorMessage(error) };
    }
  };

  const [register, handleChange, handleSubmit, errors] = useFormValidator(submit);

  const onChange = (e) => {
    const value = e.target.value;
    setTopic((prev) => ({ ...prev, [e.target.name]: value === "" ? null : value }));
  };

  const inputs = [
    {
      label: "Name",
      type: "text",
      name: "name",
      value: topic && topic.name ? topic.name : "",
      placeholder: "Enter name...",
      onChange: (e) => handleChange(e, onChange),
      register: register,
      checks: ["empty"],
      errors: errors,
    },
  ];

  useEffect(() => {
    if (handleSubmit) {
      submitRef.current = { submit: handleSubmit };
      setEnableSubmit(true);
    } else {
      submitRef.current = null;
      setEnableSubmit(false);
    }
    return () => {
      submitRef.current = null;
    };
  }, [handleSubmit]);

  useEffect(() => {
    (async () => {
      if (!topicId) return;
      setLoading && setLoading(true);
      try {
        const response = await request("GET", `topics/${topicId}`);
        setTopic(response && !Array.isArray(response) ? response : null);
      } catch (error) {
        console.log(error);
        setTopic(null);
      }
      setLoading && setLoading(false);
    })();
  }, [topicId]);

  return (
    <FormValidator>
      {topic && (
        <div className="flex flex-col w-full h-auto shrink-0 space-y-4">
          <Inputs inputs={inputs} minWidth={240} onSubmit={handleSubmit} />
        </div>
      )}
    </FormValidator>
  );
};

export default EditTopic;